import { createAction, props } from '@ngrx/store';

export const taskState = createAction(
    '[taskState] Set Task State',
    props<{ data: any }>()
);

// export const changeUserStatus = createAction(
//   "[userState] Change User State",
//   props<{ data: any }>()
// );
